import React from 'react';

import { Box, Grid, Typography } from '@material-ui/core';

import BateriaIcon from '../../../../assets/img/assistance/assistance_type/assistance_type_battery.svg';
import GruaIcon from '../../../../assets/img/assistance/assistance_type/assistance_type_crane.svg';
import CombustibleIcon from '../../../../assets/img/assistance/assistance_type/assistance_type_fuel.svg';
import CerraduraIcon from '../../../../assets/img/assistance/assistance_type/assistance_type_lock.svg';
import NeumaticoIcon from '../../../../assets/img/assistance/assistance_type/assistance_type_tire.svg';
// import BateriaIcon from '../../../../assets/img/bateria.png';
// import CerraduraIcon from '../../../../assets/img/cerradura.png';
// import CombustibleIcon from '../../../../assets/img/combustible.png';
// import GruaIcon from '../../../../assets/img/grua.png';
// import NeumaticoIcon from '../../../../assets/img/neumatico.png';
import {
  ASSISTANCE_TYPE_BATTERY,
  ASSISTANCE_TYPE_GAS,
  ASSISTANCE_TYPE_LOCKSMITH,
  ASSISTANCE_TYPE_TIRE,
  ASSISTANCE_TYPE_TOWING,
} from '../../../../constants/assistance.constant';
import SelectionCards from '../Subcomponents/SelectionCards.component';

const EMERGENCIES = [
  {
    title: 'Necesito una grúa',
    icon: GruaIcon,
    value: ASSISTANCE_TYPE_TOWING,
    tipificationKey: 'ASSISTANCE_NEED_CRANE',
  },
];

const PROBLEMS = [
  {
    title: 'Problemas con la batería',
    icon: BateriaIcon,
    value: ASSISTANCE_TYPE_BATTERY,
    tipificationKey: 'ASSISTANCE_BATTERY_PROBLEM',
  },
  {
    title: 'No tiene combustible',
    icon: CombustibleIcon,
    value: ASSISTANCE_TYPE_GAS,
    tipificationKey: 'ASSISTANCE_LACK_FUEL',
  },
  {
    title: 'Se pinchó un neumático',
    icon: NeumaticoIcon,
    value: ASSISTANCE_TYPE_TIRE,
    tipificationKey: 'ASSISTANCE_TIRE_PUNCTURED',
  },
  {
    title: 'Problemas con la cerradura',
    icon: CerraduraIcon,
    value: ASSISTANCE_TYPE_LOCKSMITH,
  },
];

const AssistanceType = () => {
  return (
    <Grid container>
      <Grid item xs={12}>
        <Box my={3}>
          <Typography variant="h6" color="textPrimary">
            ¿Qué le sucedió al vehículo?
          </Typography>
        </Box>
      </Grid>
      <Grid item xs={12}>
        <Box>
          <Typography variant="caption">Tengo una emergencia</Typography>
        </Box>
      </Grid>
      <SelectionCards
        relatedField={'assistance_type'}
        cards={EMERGENCIES}
      ></SelectionCards>
      <Grid item xs={12}>
        <Box mt={3}>
          <Typography variant="caption">¿Identificaste el problema?</Typography>
        </Box>
      </Grid>
      <SelectionCards
        relatedField={'assistance_type'}
        cards={PROBLEMS}
      ></SelectionCards>
    </Grid>
  );
};

export default AssistanceType;
